export default "__VITE_ASSET__WKE4J9iY__"